import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import LegalDocument from '../components/LegalDocument';
import { privacyPolicyContent } from '../content/privacyPolicy';

const PrivacyPolicyPage = () => {
  return <LegalDocument content={privacyPolicyContent} icon={ShieldCheckIcon} />;
};

export default PrivacyPolicyPage;
